/* eslint-disable
    consistent-return,
    no-return-assign
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS104: Avoid inline assignments
 * DS204: Change includes calls to have a more natural evaluation order
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from 'backbone';
import $ from 'jquery';
import _ from 'underscore';

class EditableTableView extends Backbone.View {
  static initClass() {
    this.prototype.rowIncrement = Infinity;
    this.prototype.className = 'editable-table';
    this.prototype.editableFields = [];
    this.prototype.tagName = 'tbody';
    this.prototype.rows = [];
    this.prototype.models = [];
    this.prototype.paginatedModels = [];
  }

  events() {
    return {
      'click .edit-text': 'handleEditText',
      'click .delete-text': 'handleDeleteText',
      'mouseenter .edit-text': function (e) {
        return this.handleIconHover(e, '.edit-text');
      },
      'mouseenter .delete-text': function (e) {
        return this.handleIconHover(e, '.delete-text');
      },
      'mouseleave .edit-text': 'handleIconUnhover',
      'mouseleave .delete-text': 'handleIconUnhover',
      'click .editable-text': 'handleEditableClick',
      'focus .editable-text': function (e) {
        return this.handleEditableFocus(e, 'text');
      },
      'focus .editable-check': function (e) {
        return this.handleEditableFocus(e, 'check');
      },
      'click .editable-check': 'handleEditableCheckClick',
      'input .editable-text': 'handleEditableInput',
      'input .editable-check': 'handleEditableInput',
      'click .editable-select': 'handleEditableSelectClick',
      'change .editable-select': 'handleEditableSelectChange',
      'change .editable-color': 'handleEditableColorChange',
      'click .editable-color': 'handleEditableColorClick',
      'click tr': 'handleClick',
      'blur .editable-text': 'handleEditableUnfocus',
      'mouseenter .editable-text': function (e) {
        return this.handleEditableHover(e, 'text');
      },
      'mouseenter .editable-check': function (e) {
        return this.handleEditableHover(e, 'check');
      },
      'mouseleave .editable-text': 'handleEditableUnhover',
      'mouseleave .editable-check': 'handleEditableUnhover',
    };
  }

  initialize() {
    this.shiftAnchorIndex = null;
    this.pageOffset = 0;
    this.$el.addClass(this.className);
    this.registerListeners();
    this.renderedRows = [];
    return (this.rows = []);
  }

  die() {
    this.stopListening();
    this.undelegateEvents();
    for (const row of Array.from(this.renderedRows)) {
      row.die();
    }
  }

  registerListeners() {
    return this.listenTo(this.collection, 'render', this.setEditables);
  }

  allowEdits() {
    return true;
  }

  allowSelecting() {
    return true;
  }

  getRowIndex(e) {
    return $(e.currentTarget).parents('tr.editable-table-row').index();
  }

  trackFieldEdit(fieldName, value) {}

  handleEditableSelectClick(e) {
    const index = this.getRowIndex(e);
    return this._handleClickHelper(e, index);
  }

  handleEditableSelectChange(e) {
    const rowIndex = this.getRowIndex(e);
    if (!this.getModel(rowIndex).selected()) {
      this._handleClickHelper(e, rowIndex);
    }
    const type = this.getEditableType($(e.currentTarget));
    const value = $(e.currentTarget).val();
    return this._handleUpdateHelper(type, value);
  }

  handleIconHover(e, selector) {
    if (!this.allowEdits()) {
      return;
    }
    const rowIndex = this.getRowIndex(e);
    const type = this.getEditableType(this.getEditableFieldFromSibling(e));
    if (!this.getModel(rowIndex).selected()) {
      return this.getModel(rowIndex).trigger('tableHoverIcon', type, selector);
    } else {
      // eslint-disable-next-line no-restricted-syntax
      return _.each(
        // eslint-disable-next-line no-restricted-syntax
        _.filter(this.paginatedModels, (model) => model.selected()),
        (model) => model.trigger('tableHoverIcon', type, selector)
      );
    }
  }

  handleIconUnhover(e) {
    return this.$el.find('.edit-text.hover, .delete-text.hover').removeClass('hover');
  }

  handleEditableCheckClick(e) {
    e.stopPropagation();

    const rowIndex = this.getRowIndex(e);
    if (!this.getModel(rowIndex).selected()) {
      this._handleClickHelper(e, rowIndex);
    }
    if (!this.allowEdits()) {
      return;
    }
    const type = this.getEditableType($(e.currentTarget));
    const prefix = $(e.currentTarget).data('prefix');
    if ($(e.currentTarget).hasClass('true')) {
      return this._handleUpdateHelper(type, undefined, prefix);
    } else {
      return this._handleUpdateHelper(type, '', prefix);
    }
  }

  handleEditableColorChange(e, color) {
    const type = this.getEditableType($(e.currentTarget));
    const model = this.getModel(this.getRowIndex(e));
    model.trigger('tableCloseColorPicker', type);
    return this._handleUpdateHelper(type, color);
  }

  handleEditableColorClick(e) {
    e.stopPropagation();

    const rowIndex = this.getRowIndex(e);
    const model = this.getModel(rowIndex);
    if (!model.selected()) {
      this._handleClickHelper(e, rowIndex);
    }
    if (!this.allowEdits()) {
      return;
    }
    const type = this.getEditableType($(e.currentTarget));
    return Array.from(this.paginatedModels).map((m) =>
      m !== model ? m.trigger('tableCloseColorPicker', type) : m.trigger('tableOpenColorPicker', type)
    );
  }

  handleEditableInput(e) {
    const type = this.getEditableType($(e.currentTarget));
    const value = $(e.currentTarget).text();
    // eslint-disable-next-line no-restricted-syntax
    return _.each(
      // eslint-disable-next-line no-restricted-syntax
      _.filter(this.paginatedModels, (model) => model.selected()),
      (model) => model.trigger('tableInputChange', type, value)
    );
  }

  handleEditableHover(e, inputType) {
    if (!this.allowEdits()) {
      return;
    }
    const rowIndex = this.getRowIndex(e);
    const type = this.getEditableType($(e.currentTarget));
    if (this.getModel(rowIndex).selected()) {
      // eslint-disable-next-line no-restricted-syntax
      return _.each(
        // eslint-disable-next-line no-restricted-syntax
        _.filter(this.paginatedModels, (model) => model.selected()),
        (model) => model.trigger('tableHover', type, inputType)
      );
    } else {
      return this.getModel(rowIndex).trigger('tableHover', type, inputType);
    }
  }

  handleEditableUnfocus(e) {
    this.trackFieldEdit(this.getEditableType($(e.currentTarget)), $(e.currentTarget).text());

    this.$el.find('.editable-text, .editable-check').removeClass('focus');

    this.$el.find('.editable-check').not('.hover').removeClass('text-editable');
  }

  handleEditableUnhover(e) {
    return this.$el.find('.editable-text, .editable-check').removeClass('hover');
  }

  handleEditableClick(e) {
    e.stopPropagation();
    const rowIndex = this.getRowIndex(e);
    const model = this.getModel(rowIndex);
    if (!model.selected()) {
      this._handleClickHelper(e, rowIndex);
    }
    return this.handleEditableFocus(e, 'text');
  }

  handleEditableFocus(e, inputType) {
    if (!this.allowEdits()) {
      return;
    }
    if (!this.getModel(this.getRowIndex(e)).selected()) {
      return;
    }
    const type = this.getEditableType($(e.currentTarget));
    return Array.from(this.paginatedModels).map((model) =>
      model.selected()
        ? model.trigger('tableFocus', type, inputType)
        : model.trigger('tableUnfocus', type, inputType)
    );
  }

  getEditableType($el) {
    const type = $el.data('type');
    if (!Array.from(this.editableFields).includes(type)) {
      throw new Error(`Unexpected element type: ${type}`);
    }

    return type;
  }

  handleEditText(e) {
    e.stopPropagation();
    const rowIndex = this.getRowIndex(e);
    if (!this.getModel(rowIndex).selected()) {
      this._handleClickHelper(e, rowIndex);
    }
    const $td = $(e.currentTarget).parents('td');
    if ($td.find('.editable-text').size() > 0) {
      return $td.find('.editable-text').focus();
    } else if ($td.find('.editable-check').size() > 0) {
      const type = this.getEditableType(this.getEditableFieldFromSibling(e));
      for (const model of Array.from(this.paginatedModels)) {
        if (model.selected()) {
          model.trigger('tableFocus', type, 'text');
        } else {
          model.trigger('tableUnfocus', type, 'text');
        }
      }

      return (
        $td
          .find('.editable-check')
          .attr('tabindex', -1)
          // eslint-disable-next-line no-restricted-syntax
          .inlineEditable(_.bind(this.handleUpdate, this), _.bind(this.handleRevert, this))
          .focus()
      );
    }
  }

  getEditableFieldFromSibling(e) {
    const $td = $(e.currentTarget).parents('td');
    return $td.find('.editable-check, .editable-text, .editable-color, .editable-select');
  }

  handleDeleteText(e) {
    e.stopPropagation();
    const rowIndex = this.getRowIndex(e);
    if (!this.getModel(rowIndex).selected()) {
      this._handleClickHelper(e, rowIndex);
    }
    const $field = this.getEditableFieldFromSibling(e);
    const type = this.getEditableType($field);
    const prefix = $field.data('prefix');
    return this._handleUpdateHelper(type, undefined, prefix);
  }

  handleClick(e) {
    const index = $(e.currentTarget).index();
    return this._handleClickHelper(e, index);
  }

  getModel(index) {
    return this.models[index + this.pageOffset];
  }

  _handleClickHelper(e, rowIndex) {
    if (!this.allowSelecting()) {
      return;
    }
    const model = this.getModel(rowIndex);
    if (e.ctrlKey || e.metaKey) {
      if (model.selected()) {
        return model.set({selected: false});
      } else {
        return model.select({multi: true});
      }
    } else if (e.shiftKey) {
      if (this.shiftAnchorIndex != null) {
        model.select(); // unselect everything else
        return __range__(this.shiftAnchorIndex, rowIndex + this.pageOffset, true).map((i) =>
          this.models[i].select({multi: true})
        );
      } else {
        model.select();
        return (this.shiftAnchorIndex = rowIndex + this.pageOffset);
      }
    } else {
      model.select();
      return (this.shiftAnchorIndex = rowIndex + this.pageOffset);
    }
  }

  getRows() {
    // returns a list of models to render
    throw new Error('Not implemented.');
  }

  makeRow() {
    // takes a model, and returns an item view.
    throw new Error('Not implemented.');
  }

  // e.currentTarget: the inlineeditable element whose model will update
  handleUpdate(e) {
    const type = this.getEditableType($(e.currentTarget));
    const val = $(e.currentTarget).text();
    const prefix = $(e.currentTarget).data('prefix');

    return this._handleUpdateHelper(type, val, prefix);
  }

  _handleUpdateHelper(type, val) {
    throw new Error('Not implemented.');
  }

  handleRevert() {
    // eslint-disable-next-line no-restricted-syntax
    return _.each(this.collection.where({selected: true}), (model) => model.trigger('tableRevert'));
  }

  renderMore() {
    // eslint-disable-next-line no-restricted-syntax
    const newRows = _.map(
      this.rows.splice(0, Math.min(this.rowIncrement, this.rows.length)),
      function (model) {
        return this.makeRow(model);
      },
      this
    );
    this.renderedRows.push(...Array.from(newRows || []));
    // eslint-disable-next-line no-restricted-syntax
    return this.$el.append(_.map(newRows, (row) => row.render().el));
  }

  remove() {
    super.remove();
    for (const row of Array.from(this.renderedRows)) {
      row.remove();
    }
    return (this.renderedRows = []);
  }

  update() {
    while (this.renderedRows.length > 0) {
      this.renderedRows.pop().remove();
    }
    this.rows = this.getRows();
    this.$el.empty();
    this.renderMore();

    if (!this.allowEdits()) {
      this.$el.find('select').attr('disabled', true);
    }

    return _.defer(() => {
      this.$el.find('div.relative').each(function (index, element) {
        return $(element).height($(this).parent('td').height());
      });

      return this.$el.find('div.relative.middle-aligned').each(function (index, element) {
        return $(element).css('line-height', `${$(this).height()}px`);
      });
    });
  }

  setEditables(model) {
    if (this.allowEdits()) {
      return model.trigger(
        'tableSetEditables',
        this.editableFields,
        // eslint-disable-next-line no-restricted-syntax
        _.bind(this.handleUpdate, this),
        // eslint-disable-next-line no-restricted-syntax
        _.bind(this.handleRevert, this)
      );
    }
  }

  render() {
    this.update();
    const $bufferTab = this.$el.closest('.buffer-tab');
    $bufferTab.on('scroll', () => {
      if ($bufferTab.scrollTop() + 30 > this.$el.height() - $bufferTab.height()) {
        return this.renderMore();
      }
    });
    return this;
  }
}
EditableTableView.initClass();

export {EditableTableView};

function __range__(left, right, inclusive) {
  const range = [];
  const ascending = left < right;
  const end = !inclusive ? right : ascending ? right + 1 : right - 1;
  for (let i = left; ascending ? i < end : i > end; ascending ? i++ : i--) {
    range.push(i);
  }
  return range;
}
